import React from 'react'
import PropTypes from 'prop-types'
import _ from 'lodash'
import QCInfoForm from './QCInfoForm'
import ResultsView from './ResultsView'
import StatsView from './StatsView'
import GraphView from './GraphView'
import { isQcComplete } from '../../../store/qc'
import constants from 'lib/constants'
import html2pdf from 'html2pdf.js'
import axios from 'axios'

const PRINT_TARGET_ID = 'qc-print-target'

window.html2pdf = html2pdf

class QCView extends React.Component {
  static propTypes = {
    qcResults: PropTypes.shape({}),
    getControlMaterials: PropTypes.func,
    createQc: PropTypes.func,
    updateQc: PropTypes.func,
    controlMaterials: PropTypes.shape({}),
    site: PropTypes.shape({}),
    runAllQc: PropTypes.func,
    runIndividualQc: PropTypes.func,
    isQcComplete: PropTypes.shape({}),
    certifyQc: PropTypes.func,
    router: PropTypes.shape({}),
    deleteQcJob: PropTypes.func,
    cancelQcJob: PropTypes.func
  }

  static defaultProps = {
    qcResults: {},
    getControlMaterials: _.noop,
    controlMaterials: {},
    runAllQc: _.noop,
    runIndividualQc: _.noop,
    site: {},
    params: {},
    certifyQc: _.noop,
    router: {},
    deleteQcJob: _.noop,
    cancelQcJob: _.noop,
  }

  constructor (ownProps) {
    super(ownProps)
    this.state = {
      controlMaterialId: _.get(ownProps.qcResults, 'control_material_id'),
      deviceString: _.get(ownProps.qcResults, 'device_string'),
      testStripLot: _.get(ownProps.qcResults, 'test_strip_lot'),
      note: _.get(ownProps.qcResults, 'note'),
      operator: _.get(ownProps.qcResults, 'operator'),
      errors: {},
      flowTimes: _.get(ownProps.qcResults, 'flow_times'),
      allowRunAgain: true,
      showLVTModal: false,
      activeTab: 'charts'
    }
    if (!this.state.deviceString) {
      this.state.deviceString = ownProps.params.device_string
    }
    if (_.size(ownProps.controlMaterials) === 1) {
      this.state.controlMaterialId = _.keys(ownProps.controlMaterials)[0]
    }
  }

  setFlowTime = (jobId, flowTime) => {
    const { qcResults, updateQc } = this.props
    const newFlowTimes = _.merge({}, this.state.flowTimes, { [jobId]: flowTime })
    this.setState({
      flowTimes:newFlowTimes
    })
    updateQc(qcResults.id, { flowTimes: newFlowTimes })
  }

  setNote = (note) => {
    this.setState({
      note
    })
  }

  setControlMaterial = (controlMaterialId) => {
    this.setState({
      controlMaterialId
    })
  }

  setOperator = (operator) => {
    this.setState({
      operator
    })
  }

  setTestStripLot = (testStripLot) => {
    this.setState({
      testStripLot
    })
  }

  startTest = () => {
    const { runAllQc, createQc, router, params } = this.props
    const { deviceString, controlMaterialId, testStripLot, note, operator } = this.state
    createQc({ deviceString, controlMaterialId, testStripLot, note, operator })
    .then((qcResult) => {
      router.push(`/qc/${params.device_string}/${qcResult.id}`)
      return runAllQc(qcResult.id)
    })
  }

  downloadPDF = () => {
    const { router } = this.props
    const printNode = document.getElementById(PRINT_TARGET_ID)
    printNode.classList.add('printing')
    const worker = () => {
      return html2pdf().from(printNode)
        .set({ jsPDF: { orientation: 'landscape' },
          pagebreak: { avoid: '.avoid', before: '.html2pdf-break-before' } })
    }
    worker().outputPdf('blob', {})
    .then((result) => {
      const data = new FormData()
      data.append('file', result)
      return axios.post(`${constants.API_URL}/forward_qc`, data)
    })
    .then(() => {
      return worker().save('qc_results.pdf')
    })
    .then(() => {
      printNode.classList.remove('printing')
      setTimeout(() => {
        router.push('/')
      }, 2000)
    })
    .catch((e) => {
      console.error('Could not save the pdf', e)
    })
  }

  finishQc = () => {
    const { certifyQc, updateQc, qcResults } = this.props
    const { deviceString, controlMaterialId, testStripLot, note, flowTimes, operator } = this.state
    updateQc(qcResults.id, { deviceString, controlMaterialId, testStripLot, note, flowTimes, operator })
    certifyQc(qcResults.id)
    .then(() => {
      return this.downloadPDF()
    })
   }

  markRunAgain = () => {
    this.setState({
      allowRunAgain: false
    })
  }





  openLVTModal = () => {
    this.setState({ showLVTModal: true })
  }

  closeLVTModal = () => {
    this.setState({ showLVTModal: false })
  }


  render () {
    const { controlMaterials, getControlMaterials, createQc, updateQc, qcResults, site, runIndividualQc, deleteQcJob, cancelQcJob, params } = this.props
    const { note, deviceString, testStripLot, controlMaterialId, flowTimes, allowRunAgain, operator, showLVTModal } = this.state
    const controlMaterial = controlMaterials[qcResults.control_material_id]
    const fieldsFilledOut = deviceString && controlMaterialId
    const isStartButtonDisabled = fieldsFilledOut && (!_.isEmpty(qcResults) && (!_.isEmpty(qcResults.low_jobs) || !_.isEmpty(qcResults.normal_jobs) || !_.isEmpty(qcResults.high_jobs)))
    const isQcFinished = isQcComplete(qcResults)
    return (
      <div style={{ textAlign: 'left', margin: 20 }} id={PRINT_TARGET_ID}>
        <QCInfoForm
          qcResults={qcResults}
          getControlMaterials={getControlMaterials}
          site={site}
          createQc={createQc}
          updateQc={updateQc}
          controlMaterials={controlMaterials}
          qcId={params.qcId}
          setControlMaterial={this.setControlMaterial}
          setNote={this.setNote}
          setOperator={this.setOperator}
          setTestStripLot={this.setTestStripLot}
          deviceString={params.device_string}
          note={note}
          operator={operator}
          controlMaterialId={controlMaterialId}
          testStripLot={testStripLot}
        />
        <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
          <div
            className='btn btn-primary'
            onClick={this.startTest}
            disabled={isStartButtonDisabled}
          >
            Start Quality Control
          </div>
        </div>
        <hr />
        <div>
          {
            qcResults.id ? (
              <div>
                <div className='html2pdf-break-before'>
                  <h4>Results</h4>
                  <ResultsView
                    level={'low'}
                    qcResults={qcResults}
                    controlMaterial={controlMaterial}
                    runIndividualQc={runIndividualQc}
                    markRunAgain={this.markRunAgain}
                    allowRunAgain={allowRunAgain}
                    deleteQcJob={deleteQcJob}
                    cancelQcJob={cancelQcJob}
                    flowTimes={flowTimes}
                    setFlowTime={this.setFlowTime}
                  />
                  <ResultsView
                    level={'normal'}
                    qcResults={qcResults}
                    controlMaterial={controlMaterial}
                    runIndividualQc={runIndividualQc}
                    markRunAgain={this.markRunAgain}
                    allowRunAgain={allowRunAgain}
                    deleteQcJob={deleteQcJob}
                    cancelQcJob={cancelQcJob}
                    flowTimes={flowTimes}
                    setFlowTime={this.setFlowTime}
                  />
                  <ResultsView
                    level={'high'}
                    qcResults={qcResults}
                    controlMaterial={controlMaterial}
                    runIndividualQc={runIndividualQc}
                    markRunAgain={this.markRunAgain}
                    allowRunAgain={allowRunAgain}
                    deleteQcJob={deleteQcJob}
                    cancelQcJob={cancelQcJob}
                    flowTimes={flowTimes}
                    setFlowTime={this.setFlowTime}
                  />
                </div>
                <div className='html2pdf-break-before'>
                  <div>
                    <ul className="nav nav-tabs" style={{ marginBottom: 20 }}>
                      <li className="nav-item">
                        <button 
                          className={`nav-link ${this.state.activeTab === 'charts' ? 'active' : ''}`}
                          onClick={() => this.setState({ activeTab: 'charts' })}
                          style={{ 
                            border: 'none', 
                            background: 'none',
                            color: this.state.activeTab === 'charts' ? '#007bff' : '#6c757d'
                          }}
                        >
                          Job Charts
                        </button>
                      </li>
                      <li className="nav-item">
                        <button 
                          className={`nav-link ${this.state.activeTab === 'statistics' ? 'active' : ''}`}
                          onClick={() => this.setState({ activeTab: 'statistics' })}
                          style={{ 
                            border: 'none', 
                            background: 'none',
                            color: this.state.activeTab === 'statistics' ? '#007bff' : '#6c757d'
                          }}
                        >
                          Statistics & Analysis
                        </button>
                      </li>
                    </ul>
                    
                    {this.state.activeTab === 'charts' && (
                      <div>
                        <GraphView qcResults={qcResults} />
                        <StatsView 
                          qcResults={qcResults}
                          controlMaterial={controlMaterial}
                          showOnlyStatus={true}
                        />
                      </div>
                    )}
                    
                    {this.state.activeTab === 'statistics' && (
                      <StatsView 
                        qcResults={qcResults}
                        controlMaterial={controlMaterial}
                        showOnlyStatistics={true}
                      />
                    )}
                  </div>
                </div>
                <div>
                  <hr />
                  <h4>Submit</h4>
                  <div>
                    <div className='btn btn-primary'
                      onClick={this.finishQc}
                      disabled={!isQcFinished}
                    >
                      Certify Qc
                    </div>
                  </div>
                </div>
              </div>
            ) : null
          }
        </div>
        </div>
    )
  }
}

export default QCView



// WEBPACK FOOTER //
// ./src/routes/QC/components/QCView.jsx